import { MonitoringTask } from 'types/apiModels'
import { apiClient } from '../../../ruutsApi/client'
import endpoints from '../../../ruutsApi/endpoints'
import { type ApiV2QueryType } from '../../../ruutsApi/types'
import { unwrapPaginated, type Paginated } from '../../../ruutsApi/normalize'

export default async function getMonitoringTasks({
  query,
  signal,
}: {
  query?: ApiV2QueryType<MonitoringTask>
  signal?: AbortSignal
}): Promise<Paginated<MonitoringTask>> {
  // An empty array is serialized away, so the endpoint would answer with every farm's tasks
  // instead of none. Asking for "the tasks of no activity" can only mean an empty page.
  if (Array.isArray(query?.monitoringActivityId) && query.monitoringActivityId.length === 0) {
    return { items: [], pagination: { page: 1, totalPages: 0, total: 0 } }
  }

  const response = await apiClient.get(endpoints.v2.monitoring.tasks, { params: query, signal })
  return unwrapPaginated<MonitoringTask>(response)
}
